module.exports = __webpack_public_path__ + "static/media/destroy_email.08e01d0a.svg";